import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, Outlet, useNavigate } from "react-router-dom";
import MyOrderAlert from "./MyOrderAlert";

const MyOrderDashboard = () => {
  const distID = localStorage.getItem("distributorId");
  const boostID = localStorage.getItem("companyIdBooster");
  const userId = localStorage.getItem("userId");
  const userType = localStorage.getItem("userType");
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [errorMsg, setErrorMsg] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("All");
  const [selectedDuration, setSelectedDuration] = useState("All");

  useEffect(() => {
    fetchOrders("All", "All");
  }, []);

  const fetchOrders = (status, duration) => {
    const requestData = {
      distributorId: distID,
      userType,
      userId,
      companyId: boostID,
      fromDate: "",
      toDate: "",
      status,
      durationInText: duration,
    };

    axios
      .post(
        "https://dpapi.boosterparis.in/api/Orders/GetRecentOrders/",
        requestData,
        {
          headers: {
            "Cache-Control": "no-cache",
            "Access-Control-Allow-Origin": "*",
            Authorization: localStorage.getItem("loginToken"),
          },
        },
      )
      .then((response) => {
        if (response.data.isSuccess) {
          setData(response.data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleFilterClick = (newStatus, newDuration) => {
    const updatedStatus = newStatus || selectedStatus;
    const updatedDuration = newDuration || selectedDuration;

    setSelectedStatus(updatedStatus);
    setSelectedDuration(updatedDuration);
    fetchOrders(updatedStatus, updatedDuration);

    // Close the filter panel when a duration is selected
    if (newDuration) {
      document.getElementById("rightFilterSidebar").classList.remove("show");
    }
  };

  const handleEditOrder = (event) => {
    event.preventDefault();
    const editOrd = event.target.id;
    axios
      .post(
        "https://dpapi.boosterparis.in/api/Orders/EditOrderLine",
        { orderLineId: editOrd },
        {
          headers: {
            "Cache-Control": "no-cache",
            "Access-Control-Allow-Origin": "*",
            Authorization: localStorage.getItem("loginToken"),
          },
        },
      )
      .then((response) => {
        if (response.data.isSuccess) {
          localStorage.setItem("ordereditOnOrderSummary", true);
          navigate("/NewOrder/OrderSummary");
        } else {
          setErrorMsg(response.data.message);
          setTimeout(() => setErrorMsg(""), 5000);
        }
      })
      .catch((error) => console.error(error));
  };

  return (
    <section className="content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="card noUI productListNewOrd">
              <div className="card-header myOrderFltUI">
                {[
                  "All",
                  "Approved",
                  "Pending",
                  "Dispatched",
                  "PartiallyDispatched",
                ].map((status) => (
                  <button
                    key={status}
                    className={`form-control flBtn listfilterhead ${
                      selectedStatus === status ? "active" : ""
                    }`}
                    onClick={() => handleFilterClick(status, null)}
                  >
                    {status}
                  </button>
                ))}
                <div className="dropdown newfilter">
                  <a
                    href
                    onClick={() =>
                      document
                        .getElementById("rightFilterSidebar")
                        .classList.toggle("show")
                    }
                  >
                    <i className="fa fa-filter prdSear"></i>
                  </a>
                </div>
                <aside className="control-sidebar" id="rightFilterSidebar">
                  <div className="p-3 control-sidebar-content">
                    <h6>
                      <i className="fa fa-filter"></i> Filter
                    </h6>
                    <ul className="addn-filters">
                      {[
                        "Today",
                        "ThisWeek",
                        "LastWeek",
                        "CurrentMonth",
                        "LastMonth",
                        "ThisFNYear",
                        "All",
                      ].map((duration) => (
                        <li key={duration}>
                          <a
                            className={`dropdown-item ${
                              selectedDuration === duration
                                ? "active bg-primary text-white"
                                : ""
                            }`}
                            href
                            onClick={(e) => {
                              e.preventDefault();
                              handleFilterClick(null, duration);
                            }}
                            style={{
                              padding: "10px",
                              borderRadius: "5px",
                              cursor: "pointer",
                            }}
                          >
                            {duration}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                </aside>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="card card-success">
              <div className="card-header d-flex justify-content-between align-items-center">
                <h3 className="card-title">My Orders</h3>
                <a href="/NewOrder">
                  {" "}
                  <button className="btn btn-primary">New Order</button>
                </a>
              </div>
              <div className="card-body">
                {/* <MyOrderAlert /> */}
                <div className="row">
                  {data.result &&
                    data.result.map((item, index) => (
                      <div key={index} className="col-md-4">
                        <div className="card card-primary">
                          <div className="card-header">
                            <h5 className="card-title">{item.orderNumber}</h5>
                          </div>
                          <div className="card-body">
                            <p>Status: {item.statusDisplayText}</p>
                            <p>Number Of Items: {item.numberOfItems}</p>
                            <p>Date: {item.orderPlacedDate}</p>
                            {item.shipToDetails !== "Self" && (
                              <p>
                                For: <b>{item.shipToDetails}</b>
                              </p>
                            )}
                            {item.isOrderEditable && (
                              <button
                                className="btn btn-success btn-sm editMO"
                                onClick={handleEditOrder}
                                id={item.id}
                              >
                                Edit
                              </button>
                            )}
                            <Link
                              to={`/OrderDetails/${item.id}`}
                              className="btn btn-primary btn-sm"
                            >
                              View Details
                            </Link>
                          </div>
                        </div>
                      </div>
                    ))}
                  {/* Show when no orders are available */}
                  {data.result && data.result.length === 0 && (
                    <div className="col-12">
                      <div className="alert alert-info text-center">
                        <strong>No Orders Found!</strong>
                        <br />
                        There are no orders matching the selected status and
                        duration.
                      </div>
                    </div>
                  )}
                  <Outlet />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MyOrderDashboard;
